import { post } from '../index';

export const inviteUserByEmail = body => {
  return post('/invites', body);
};
